// extracted by mini-css-extract-plugin
module.exports = {"title":"_2Vmgh","headband":"wJ9MO","blockTitleLink":"_1XHZK","buttonLink":"_3114F"};